import type {PodRequestFn} from '../usePodRequest';

const OUTLOOK_ADD_IN_PEOPLE_FROM_EMAIL_ADDRESSES_PATH =
  '/outlook_add_in/people_from_email_addresses';

export type OutlookPersonFromEmailJson = {
  id: number;
  name: string;
  profile_picture_thumb_url?: string | null;
  loxo_url: string;
  emails: Array<{
    id: number;
    value: string;
    position?: number | null;
    sync: boolean;
  }>;
  can_write?: boolean;
};

export type OutlookPeopleFromEmailAddressesJson = {
  people: OutlookPersonFromEmailJson[];
  email_addresses_for_sync: string[];
};

export const buildOutlookPeopleFromEmailAddressesPath = (
  agencyId: number,
  emailAddresses: readonly string[]
): string => {
  const params = new URLSearchParams();
  params.set('agency_id', String(agencyId));
  for (const raw of emailAddresses) {
    const email = raw.trim();
    if (email) {
      params.append('email_addresses[]', email);
    }
  }
  const qs = params.toString();
  return `${OUTLOOK_ADD_IN_PEOPLE_FROM_EMAIL_ADDRESSES_PATH}?${qs}`;
};

export const fetchOutlookPeopleFromEmailAddresses = async (
  request: PodRequestFn,
  agencyId: number,
  emailAddresses: readonly string[],
  init?: RequestInit
): Promise<OutlookPeopleFromEmailAddressesJson> => {
  const path = buildOutlookPeopleFromEmailAddressesPath(
    agencyId,
    emailAddresses
  );
  const response = await request(path, init);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookPeopleFromEmailAddressesJson;
};
